module.exports = __webpack_public_path__ + "img/icon_normal_inform@2x.0ce6733d.png";